import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
    const [content, setContent] = useState(null);
    const [services, setServices] = useState([]);
    const [gallery, setGallery] = useState([]);
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const [c, s, g, t] = await Promise.all([
                api.get("/content"),
                api.get("/services"),
                api.get("/gallery"),
                api.get("/testimonials"),
            ]);
            setContent(c.data);
            setServices(s.data);
            setGallery(g.data);
            setTestimonials(t.data);
        } catch (e) {
            // Silent fail — landing keeps rendering with fallbacks
            console.error("Content load failed", e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    return (
        <ContentContext.Provider
            value={{ content, services, gallery, testimonials, loading, refresh, setContent, setServices, setGallery, setTestimonials }}
        >
            {children}
        </ContentContext.Provider>
    );
};

export const useContent = () => useContext(ContentContext);
